import createOrgRoute from "../api/tenants/create-org.route";
import joinOrgRoute from "../api/tenants/join-org.route";
import renameOrgRoute from "../api/tenants/rename-org.route";
import lookupOrgRoute from "../api/tenants/lookup-org.route";
import myOrgsRoute from "../api/tenants/my-orgs.route";
import updateOrgInvitesRoute from "../api/tenants/update-org-invites.route";
import getPreferencesRoute from "../api/tenants/preferences/index.route";
import updateFeatureFlagsRoute from "../api/tenants/update-feature-flags.route";
import updatePreferencesRoute from "../api/tenants/preferences/update.route";
import { post } from "./lib";

type MyOrgsResponse = {
  data: {
    id: string;
    role: "super" | "admin" | "user" | "viewer" | "blocked";
    name: string;
    signupEmail: string;
  }[];
};

export const getMyOrgs = () =>
  post<typeof myOrgsRoute, MyOrgsResponse>("/api/tenants/my-orgs");

export const getOrg = (orgId: string) =>
  post<typeof lookupOrgRoute>("/api/tenants/lookup-org", { orgId });

export const createNewOrg = (
  email: string,
  name?: string,
  subscriptionId?: string
) =>
  post<typeof createOrgRoute>("/api/tenants/create-org", {
    email,
    name,
    subscriptionId,
  });

export const joinOrg = (inviteCode: string) =>
  post<typeof joinOrgRoute>("/api/tenants/join-org", { inviteCode });

export const renameOrg = (orgId: string, name: string) =>
  post<typeof renameOrgRoute>("/api/tenants/rename-org", { orgId, name });

export const updateOrgInvites = (orgId: string, enabled: boolean) =>
  post<typeof updateOrgInvitesRoute>(`/api/tenants/update-org-invites`, {
    orgId,
    openInvites: enabled ? 1 : 0,
  });

export const getPreferences = () =>
  post<typeof getPreferencesRoute>("/api/tenants/preferences");

export const updateFeatureFlags = (flags: { self_service: boolean }) =>
  post<typeof updateFeatureFlagsRoute>(
    "/api/tenants/update-feature-flags",
    flags
  );

export const updatePreferences = ({
  theme,
  notifTimeout,
}: {
  theme: string;
  notifTimeout: number;
}) =>
  post<typeof updatePreferencesRoute>("/api/tenants/preferences/update", {
    theme,
    notifTimeout,
  });
